const OWNERSHIP_TRANSFER_MODAL_TYPES = ['ONGOING_POLICY_CAR', 'CAR_EXPIRING']

export const OWNERSHIP_TRANSFER_CTA_TEXT = 'I have bought this car'

export const shouldUseOwnershipTransferCta = (modalType?: string, illogicalFlowData?: any) => {
  const errorContext = illogicalFlowData?.error_context || illogicalFlowData
  return errorContext?.skip_ownership_transfer !== true && OWNERSHIP_TRANSFER_MODAL_TYPES.includes(modalType || '')
}

const formatRegistrationNumber = (registrationNumber?: string) =>
  (registrationNumber || '').toUpperCase().replace(/[. ,:-]+/g, '')

export const getOwnershipTransferUrl = (registrationNumber?: string) => {
  const params = new URLSearchParams({
    current_node: 'ownership_transfer_options_node',
    registration_number: formatRegistrationNumber(registrationNumber),
  })

  return `/gi/auto-storefront/fresh-car/ownership-transfer-options?${params.toString()}`
}
